<template>
  <li @click="showDetail()">
    <div class="order-info">
      <span class="c-util-button type-line-gray type-small type-round">
        <span class="bold"> {{ props.item.dlvMthdNm }} </span>
      </span>
      <ul class="list">
        <li class="item">
          <strong> 주문일자 : </strong>
          <span> {{ props.item.orderDt }} </span>
        </li>
        <li class="item">
          <strong> 페인트 프로 주문번호 : </strong>
          <span> {{ props.item.orderNo }} </span>
        </li>
        <li class="item">
          <strong> SAP 주문번호 : </strong>
          <span> {{ props.item.sapOrderNo }} </span>
        </li>
        <!-- <li class="item">
          <strong> 납품 문서번호 : </strong>
          <span> {{ props.item.vbelnLf }} </span>
        </li> -->
      </ul>
    </div>
    <div class="info-detail">
      <div class="product-info">
        <span class="color-primary">제품코드 {{ props.item.matnr }}</span>
        <p>
          {{ props.item.zzmaktx }}
        </p>
      </div>
    </div>
  </li>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const emit = defineEmits(["detail"]);

function showDetail() {
  emit("detail", props.item);
}
</script>
